import {Component, computed, signal} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormsModule, NgForm} from '@angular/forms';
import {NgOtpInputComponent} from 'ng-otp-input';
import {AuthService} from '../../shared/services/auth';
import {LoaderService} from '../../shared/services/loader';
import {finalize} from 'rxjs';
import {SnackBarService} from '../../shared/services/snackbar';
import {DialogService} from '../../shared/services/dialog';

enum Page {
  PHONE_NUMBER,
  OTP
}

@Component({
  selector: 'app-login',
  imports: [FormsModule, NgOtpInputComponent],
  templateUrl: './login.html',
  styleUrl: './login.css',
})
export class Login {
  Page = Page;
  currentPage = signal<Page>(Page.PHONE_NUMBER);
  phoneNumber = signal<string>("");
  otp: string = '';
  resendOtpTimer = signal<number>(30);
  displayResendOtpTimeRemaining = computed(() => {
    return `${this.resendOtpTimer()} s`
  });
  private resendOtpIntervalId?: number;

  constructor(private router: Router, private authService: AuthService, private loader: LoaderService, private snackbar: SnackBarService,
              private dialog: DialogService, private route: ActivatedRoute) {}

  ngOnInit() {
    this.currentPage.set(this.Page.PHONE_NUMBER);
  }
  onSendOtp(loginForm: NgForm) {
    this.loader.start();
    this.phoneNumber.set(loginForm.value.phoneNumber);
    this.authService
      .sendOtp(loginForm.value.phoneNumber)
      .pipe(finalize(() => this.loader.stop()))
      .subscribe({
      next: res => {
        this.snackbar.success("OTP sent successfully.");
        this.currentPage.set(this.Page.OTP);
        this.startResendOtpTimer();
      },
      error: err => {
        console.log(err);
      }
    });
  }

  startResendOtpTimer() {
    clearInterval(this.resendOtpIntervalId);
    this.resendOtpTimer.set(30)
    this.resendOtpIntervalId = setInterval(() => {
      const current = this.resendOtpTimer();

      if (current <= 0) {
        clearInterval(this.resendOtpIntervalId);
        return;
      }
      this.resendOtpTimer.set(current - 1);
    }, 1000);
  }

  /**
   * Authenticate user
   * @param  {NgForm} form
   */
  login(form: NgForm) {
    this.loader.start();

    this.authService
      .login(this.phoneNumber(), this.otp)
      .pipe(
        finalize(() => this.loader.stop())
      )
      .subscribe({
        next: (res: VerifyOtpResponse) => {
          const { accessToken, refreshToken } = res;
          this.authService.setUserAuthenticated();
          this.authService.setAuthToken(accessToken);
          this.authService.setRefreshToken(refreshToken);
          const returnUrl =
            this.route.snapshot.queryParamMap.get('returnUrl') || '/home';
          this.router.navigateByUrl(returnUrl).then((message) => {
            console.log(message);
          }).catch((err)=> {
            console.error(err);
          });
        },
        error: (err) => {
          console.error('Login failed', err);
        }
      });

  }
  /**
   * Register new user
   * @param  {NgForm} form
   */
  onSignup(form: NgForm) {
    // if (form.invalid) {
    //   return;
    // }
    // this.authService.createUser(form.value.email, form.value.password)
    //   .subscribe(() => {
    //       this.ngxLoader.stop(); // Stop loader
    //       this.userCreated = true;
    //       form.reset();
    //       setTimeout(() => {
    //         location.reload(); // Reload page
    //       }, 700);
    //     },
    //     () => {
    //       this.ngxLoader.stop();
    //     });
  }
  resendOtp() {
    this.loader.start();
    this.authService
      .sendOtp(this.phoneNumber())
      .pipe(finalize(() => this.loader.stop()))
      .subscribe({
        next: () => {
          this.snackbar.success("OTP sent successfully.");
          this.startResendOtpTimer();
        },
        error: err => {
          console.log(err);
        }
      });
  }

  handleOtpChange(otpValue: string) {
    this.otp = otpValue;
    console.log('Current OTP:', this.otp);
  }
  ngOnDestroy() {
    clearInterval(this.resendOtpIntervalId);
  }
}


